import { useListView } from '../../core/ListViewProvider'
import { EmpresasClienteListGrouping } from './EmpresasClienteListGrouping'
import { EmpresasClienteListSearchComponent } from './EmpresasClienteListSearchComponent'
import { EmpresasClienteListToolbar } from './EmpresasClienteListToolbar'

export const EmpresasClienteListHeader = () => {
  const { selected } = useListView()
  return (
    <div className='card-header border-0 pt-6'>
      <EmpresasClienteListSearchComponent
        actions={
          selected.length > 0 ? <EmpresasClienteListGrouping /> : <EmpresasClienteListToolbar />
        }
      />
    </div>
  )
}
